import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Button,
  IconButton,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Tooltip,
} from "@mui/material";
import { AiOutlineEye } from "react-icons/ai";
import { Offcanvas, OffcanvasBody } from "react-bootstrap";
import { useSelector } from "react-redux";
import { CiFilter } from "react-icons/ci";
import { useTheme } from "../../ThemeContext";
import { DataGrid } from "@mui/x-data-grid";
import { getMyLeaveRequest } from "../../apis/apiService";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import Loader from "../../components/common/Loader";
import { AddLeave } from "./AddLeave";
import { LeaveDeatils } from "./LeaveDeatils";
import FilterLeave from "./FilterLeave";
import { useForm } from "react-hook-form";
import { Modal, ModalBody } from "react-bootstrap";

function MyLeaveRequest() {
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { isDarkMode } = useTheme();

  const [rows, setRows] = useState([]);
  const [counts, setCounts] = useState({
    total_balance: 0,
    leaves_left_in_month: 0,
    total_permissions: 0,
    total_lop: 0,
  });
  const [loading, setLoading] = useState(false);
  const [showLeave, setShowLeave] = useState(false);
  const [showLeaveDetails, setShowLeaveDetails] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [leaveFilter, setLeaveFilter] = useState("all");
  const [anchorEl, setAnchorEl] = useState(null);
  const token = localStorage.getItem("access_token");
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState({});

  const handleShowLeave = () => setShowLeave(true);
  const handleCloseLeave = () => setShowLeave(false);
  const handleShowLeaveDetails = () => setShowLeaveDetails(true);
  const handleCloseLeaveDetails = () => {
    setShowLeaveDetails(false);
    setTimeout(() => {
      setSelectedLeave(null);
    }, 300);
  };
  const handleShowFilter = () => setShowFilter(true);
  const handleCloseFilter = () => setShowFilter(false);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  const LeaveFilter = [
    { value: "all", label: "All" },
    { value: "full_day", label: "Full Day" },
    { value: "half_day", label: "Half Day" },
    { value: "2hrs_permission", label: "2 Hrs Permission" },
    { value: "comp_full_day", label: "Compensation Full Day" },
    { value: "comp_half_day", label: "Compensation Half Day" },
    { value: "wfh", label: "Work From Home" },
  ];

  const handleView = (row) => {
    setSelectedLeave(row);
    handleShowLeaveDetails();
  };

  const fetchAllLeaveRequest = useCallback(
    async (employee_id) => {
      setLoading(true);
      try {
        const queryParams = new URLSearchParams();
        queryParams.append("employee_id", employee_id);

        const leaveTypeMap = {
          all: "0",
          full_day: "1",
          half_day: "2",
          "2hrs_permission": "3",
          comp_full_day: "4",
          comp_half_day: "5",
          wfh: "6",
        };
        queryParams.append("leave_type_id", leaveTypeMap[leaveFilter] || "0");

        if (appliedFilters.leaveType) {
          queryParams.append("leave_type", appliedFilters.leaveType);
        }
        if (appliedFilters.status) {
          queryParams.append("status", appliedFilters.status);
        }
        if (appliedFilters.startDate) {
          queryParams.append(
            "date",
            dayjs(appliedFilters.startDate).format("YYYY-MM-DD")
          );
        }

        const currentDate = new Date();
        queryParams.append(
          "month",
          String(currentDate.getMonth() + 1).padStart(2, "0")
        );
        queryParams.append("year", currentDate.getFullYear());
        queryParams.append("filter_user_id", employee_id);

        const response = await getMyLeaveRequest(
          `leaverequest/getAllLeaves?${queryParams.toString()}`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response?.data) {
          const validLeaves = response.data.leaves || [];
          setRows(
            validLeaves.map((leave, index) => ({
              id: leave.leave_id ?? `row-${index}`,
              leave_type: leave.leave_type ?? "-",
              date_of_leave: leave.date_of_leave
                ? dayjs(leave.date_of_leave).format("DD MMM YYYY")
                : "-",
              time:
                leave.from_time && leave.to_time
                  ? `${leave.from_time} - ${leave.to_time}`
                  : "-",
              status: leave.status ?? "-",
              comments:
                leave.dev_comments || leave.admin_comments || "No comments",
            }))
          );
          setCounts(response.data.counts || {});
        } else {
          setRows([]);
          toast.info("No leave requests found.");
        }
      } catch (error) {
        toast.error(error.message || "Failed to fetch leave requests.");
        console.error("Error fetching leaves:", error);
      } finally {
        setLoading(false);
      }
    },
    [leaveFilter, appliedFilters, token]
  );

  useEffect(() => {
    if (login_user?.id) {
      fetchAllLeaveRequest(login_user.id);
    }
  }, [fetchAllLeaveRequest, login_user?.id]);

  const columns = [
    {
      field: "leave_type",
      headerName: "Leave Type",
      width: 300,
      headerAlign: "left",
      align: "Left",
    },
    {
      field: "actions",
      headerName: "Action",
      width: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <div
          onClick={() => handleView(params.row)}
          style={{ cursor: "pointer", width: "100%", textAlign: "center" }}
        >
          <Tooltip title="View Details" arrow>
            <IconButton
              sx={{
                color: "green",
                padding: "6px",
                pointerEvents: "none", // important
              }}
            >
              <AiOutlineEye />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },

    {
      field: "time",
      headerName: "Time",
      width: 250,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "date_of_leave",
      headerName: "Date of Leave",
      width: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const value = params.value?.toLowerCase();
        const statusClass =
          value === "requested"
            ? "status-requested"
            : value === "declined"
            ? "status-declined"
            : value === "approved"
            ? "status-approved"
            : "";

        return (
          <Box
            sx={{
              width: "100%",
              height: "100%", // Ensure the box takes the full cell height
              display: "flex",
              justifyContent: "center", // Center horizontally
              alignItems: "center", // Center vertically
            }}
          >
            <Typography
              variant="body2"
              className={statusClass}
              sx={{
                textTransform: "capitalize",
                width: "100%",
                textAlign: "center",
              }}
            >
              {params.value}
            </Typography>
          </Box>
        );
      },
    },
    // {
    //     field: "comments",
    //     headerName: "Comments",
    //     width: 600,
    //     headerAlign: "left",
    //     align: "left",
    // },
    {
      field: "comments",
      headerName: "Comments",
      width: 600,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => {
        const value = params.value || "";
        const truncated =
          value.length > 50 ? `${value.slice(0, 50)}...` : value;

        return (
          <Tooltip title={value} arrow>
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
                maxWidth: "100%",
              }}
            >
              {truncated}
            </span>
          </Tooltip>
        );
      },
    },
  ];

  const handleExport = () => {
    toast.info("Export functionality not implemented yet.");
    handleCloseMenu();
  };
  const handleLeaveSubmitted = () => {
    if (login_user?.id) fetchAllLeaveRequest(login_user.id);
    handleCloseLeave();
  };

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      leaveType: "",
      startDate: null,
      status: "",
    },
  });

  const handleClearFilter = () => {
    reset({
      leaveType: "",
      startDate: null,
      status: "",
    });
    setAppliedFilters({});
  };

  return (
    <div style={{ padding: "16px" }} className="bg-white">
      <Box sx={{ width: "100%", backgroundColor: "transparent" }}>
        {/* Request Leave Offcanvas */}
        <Offcanvas
          show={showLeave}
          placement="end"
          className="custom-offcanvas"
          style={{ width: window.innerWidth <= 768 ? "80%" : "50%" }}
        >
          <OffcanvasBody className="p-0">
            <AddLeave
              onCancel={handleCloseLeave}
              onSuccess={handleLeaveSubmitted}
            />
          </OffcanvasBody>
        </Offcanvas>

        {/* Leave Details Offcanvas */}
        {/* <Offcanvas
                    show={showLeaveDetails}
                    placement="end"
                    className="custom-offcanvas"
                    style={{ width: window.innerWidth <= 768 ? "80%" : "400px" }}
                >
                    <OffcanvasBody className="p-0">
                        {selectedLeave && (
                            <LeaveDeatils
                                onCancel={handleCloseLeaveDetails}
                                leave={selectedLeave}
                            />
                        )}
                    </OffcanvasBody>
                </Offcanvas> */}

        <Modal
          show={showLeaveDetails}
          onHide={handleCloseLeaveDetails}
          centered
          // animation={true}
          keyboard={false}
        >
          <ModalBody className="p-0">
            {selectedLeave && (
              <LeaveDeatils
                onCancel={handleCloseLeaveDetails}
                leave={selectedLeave}
              />
            )}
          </ModalBody>
        </Modal>

        {/* Filter Offcanvas */}
        <Offcanvas
          show={showFilter}
          placement="end"
          style={{ width: window.innerWidth <= 768 ? "80%" : "50%" }}                                  
          onHide={handleCloseFilter}
        >
          <OffcanvasBody className="p-0">
            <FilterLeave
              onApply={(filters) => {
                setAppliedFilters(filters);
                handleCloseFilter();
              }}
              onClear={() => setAppliedFilters({})}
              onCancel={handleCloseFilter}
            />
          </OffcanvasBody>
        </Offcanvas>

        {/* Top Controls */}
          <Box
          className="d-flex align-items-center justify-content-between flex-nowrap gap-3"                                          
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "11px 16px",
            marginBottom: "16px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
          }}
        >
          <div className="d-flex align-items-center gap-3 flex-nowrap">
            <Typography
              variant="body2"
              sx={{ color: isDarkMode ? "#9ca3af" : "#666", fontSize: "0.9rem", minWidth: "100px" }}
            >
              Leave Type
            </Typography>
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select
                value={leaveFilter}
                onChange={(e) => setLeaveFilter(e.target.value)}
                displayEmpty
                sx={{ borderRadius: "5px" }}
              >
                {LeaveFilter.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {/* <div
            className="d-flex align-items-center justify-content-center px-3 py-2"
            style={{
              border: "1px solid #00C4CC",
              borderRadius: "6px",
              minWidth: "600px",
              backgroundColor: isDarkMode ? "#1E1E2F" : "#f9fdfd", // Dark background in dark mode
            }}
          >
            {[
              // { label: "Current Balance Leave", value: counts.total_balance },
              {
                label: "Leave in this Month",
                value: counts.leaves_left_in_month,
              },
              {
                label: "Permission in this Month",
                value: counts.total_permissions,
              },
              // { label: "LOP in this Month", value: counts.total_lop },
            ].map((item, index, arr) => (
              <div
                key={index}
                className="text-center flex-fill"
                style={{
                  padding: "0 12px",
                  borderRight:
                    index !== arr.length - 1 ? "1px solid #ddd" : "none",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "0.8rem",
                    color: isDarkMode ? "#ccc" : "#666", // Light text in dark mode
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: "bold",
                    color: isDarkMode ? "#fff" : "#000", // White text for value in dark mode
                  }}
                >
                  {item.value === 0 ? "0" : String(item.value).padStart(2, "0")}
                </Typography>
              </div>
            ))}
          </div> */}

          <div className="d-flex align-items-center gap-2 flex-nowrap">
            <Button
              className="rounded text-capitalize AddButton me-1 ms-2"
              onClick={handleShowLeave}
            >
              Request Leave
            </Button>
            {Object.keys(appliedFilters).length > 0 && (
              <button
                className="addmore_btn"
                disabled={loading}
                onClick={() => {
                  handleClearFilter();
                  setAppliedFilters({});
                }}
              >
                Clear Filter
              </button>
            )}

            <Tooltip title="Filter">
              <IconButton
                sx={{
                  backgroundColor: isDarkMode ? "rgba(67, 105, 255, 0.08)" : "#F1F5FF",
                  borderRadius: "50%",
                  marginLeft:"10px",
                  width: "40px",
                  height: "40px",
                  padding:"5px",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                }}
                onClick={handleShowFilter}
              >
                <CiFilter className="text-rgbr-blue" size={23} />
              </IconButton>
            </Tooltip>
            {/* <IconButton
                            sx={{
                                backgroundColor: isDarkMode ? "rgba(67, 105, 255, 0.08)" : "#F1F5FF",
                                borderRadius: "50%",
                                width: "36px",
                                height: "36px",
                            }}
                            onClick={handleMenuOpen}
                        >
                            <SlOptions className="text-rgbr-blue" size={20} />
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleCloseMenu}
                            PaperProps={{ sx: { borderRadius: "8px" } }}
                        >
                            <MenuItem onClick={handleExport}>Export</MenuItem>
                        </Menu> */}
          </div>
        </Box>
      </Box>

      {loading ? (
        <Loader />
      ) : rows.length === 0 ? (
        <Table
          stickyHeader
          sx={{
            boxShadow: "none",
            marginTop: "16px",
            borderCollapse: "collapse",
            "& td, & th": {
              borderRight: "1px solid rgba(224, 224, 224, 1)",
              borderTop: "1px solid rgba(224, 224, 224, 1)",
            },
            // "& td:last-child, & th:last-child": {
            //   borderRight: "none", // remove extra right border
            // },
          }}
        >
          <TableBody>
            <TableRow>
              <TableCell sx={{ textAlign: "center", height: 200 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    fontSize: "16px",
                    fontWeight: "bold",
                    backgroundColor: isDarkMode ? "#272626" : "#f0f0f0",
                    color: isDarkMode ? "white" : "#888",
                  }}
                >
                  No data found
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      ) : (
        <div className="mt-2">
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            autoHeight
            disableRowSelectionOnClick
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f0f0f0",
                fontWeight: "bold",
                fontSize: "14px",
              },
              "& .MuiDataGrid-columnHeader--alignLeft .MuiDataGrid-columnHeaderTitle":
                {
                  paddingLeft: "16px",
                },
              "& .MuiDataGrid-cell--textLeft": {
                paddingLeft: "25px", // Add padding to left-aligned cell content
              },
              "& .MuiDataGrid-cell": {
                borderRight: "1px solid #e0e0e0",
                fontSize: "13px",
                color: "#444",
                whiteSpace: "normal",
                wordBreak: "break-word",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f9f9f9",
              },
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
            }}
          />
        </div>
      )}
    </div>
  );
}

export default MyLeaveRequest;
